export * from './pages/Connect';
export * from './pages/PhysicalTerminals';
export * from './pages/SoftPosTerminals';